'use client';

import styled, { keyframes } from 'styled-components';

import { colors } from '@/styles/theme';

const pulseAnimation = keyframes`
  0% {
    opacity: 0.6;
    transform: scale(0.98);
  }
  50% {
    opacity: 0.8;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(0.98);
  }
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  grid-column: span 4;

  p {
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.2;
  }

  .loading {
    display: block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${colors.blue};
    animation: ${pulseAnimation} 1.5s ease-in-out infinite;
  }
`;

export const Container = styled.div`
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(4, 1fr);

  gap: 18px;

  @media (max-width: 1320px) {
    grid-template-columns: repeat(3, 1fr);

    ${Message} {
      grid-column: span 3;
    }
  }

  @media (max-width: 936px) {
    grid-template-columns: repeat(2, 1fr);

    ${Message} {
      grid-column: span 2;
    }
  }

  @media (max-width: 618px) {
    grid-template-columns: repeat(1, 1fr);

    ${Message} {
      grid-column: span 1;
    }
  }
`;
